import {
  Box,
  Dialog,
  DialogContent,
  DialogProps,
  Grid,
  IconButton,
  Menu,
  MenuItem,
  Tooltip
} from '@mui/material';
import { useCallback, useEffect, useRef, useState } from 'react';
import './TruckZone.scss';
import constants from '../../../../../utils/constants';
import CustomIconButton from '../../../../../common/components/buttons/CustomIconButton';
import { Icon } from '@iconify/react';
import CustomDataGrid from '../../../../../common/components/customized/customdatagrid/CustomDataGrid';
import AddTrailers from './AddTrailers';
import AddFreights from '../../trips/loads/AddFreights';
import CustomDeletePopup from '../../../../../common/components/customdelete/CustomDeletePopup';
import CustomActivatePopup from '../../../../../common/components/customactive/CustomActivatePopup';
import { useAppDispatch, useAppSelector } from '../../../../../app/redux/hooks';
import { GridCellProps } from '@mui/x-data-grid';
import {
  deleteFreight,
  getFreight,
  PatchFreight
} from '../../../redux/reducer/truckManagementSlices/freightSlice';
import { getTruck } from '../../../redux/reducer/truckManagementSlices/truckSlice';
import CustomTab from '../../../../../common/components/tab/CustomTab';
import AddTrucksZone from './AddTrucksZone';
import CustomButton from '../../../../../common/components/buttons/CustomButton';
import { useForm } from 'react-hook-form';
import {
  capitalizeFirstLetter,
  useAbort,
  usePagination
} from '../../../../../utils/commonFunctions';
import { Stop } from '@mui/icons-material';
import CustomSearch from '../../../../../common/components/customized/customsearch/CustomSearch';
import FilePresentIcon from '@mui/icons-material/FilePresent';
import CustomCarousel from '../../../../../common/components/carousel/CustomCarousel';
import styled from '@emotion/styled';
import {
  deactiveTrailer,
  deleteTrailer,
  getTrailer
} from '../../../redux/reducer/truckManagementSlices/trailerSlice';

export interface PaginationModel {
  page: number;
  pageSize: number;
}

const Trucks = () => {
  const [type, setType] = useState<string>('');
  const [open, setOpen] = useState<boolean>(false);
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const [isDelete, setIsDelete] = useState<boolean>(false);
  const [isUpdate, setIsUpdate] = useState<boolean>(false);
  const [message, setMessage] = useState<string>('');
  const [isActivate, setIsActivate] = useState<boolean>(false);
  const [filteredRow, setFilteredRow] = useState<null | any>();
  const [trailerRows, setTrailerRows] = useState([]);
  const [freightRows, setFreightRows] = useState([]);
  const [truckRows, setTruckRows] = useState([]);
  const [role, setRole] = useState<string>('');
  const [label, setLabel] = useState('');
  const [tabValue, setTabValue] = useState(0);
  const [truckzoneType, setTruckzoneType] = useState('Trailer');
  const [sortModel, setSortModel] = useState<any>([]);
  const [index, setIndex] = useState(0);
  const [inputValue, setInputValue] = useState<any>('');
  const [imageCard, setImageCard] = useState<boolean>(false);
  const [files, setFiles] = useState<any[]>([]);
  const [textValue, setTextValue] = useState<any | any>('');
  const createAbort = useAbort();
  const { pageSize, pageNo, pagination, setPageNo, setPageSize } = usePagination();
  const [tablePayload, setTablePayload] = useState({
    pageNo: 1,
    pageSize: 5,
    sortColumnName: null,
    sortBy: null,
    searchInput: null,
    searchColumnName: null
  });

  const intervalId = useRef<NodeJS.Timeout | null>(null);

  const dispatch = useAppDispatch();

  const { data, isLoading, count } = useAppSelector(state => state.AddFreight);
  const {
    data: rows,
    isLoading: loading,
    count: trailerCount
  } = useAppSelector(state => state.getTrailer);
  const { isLoading: deleteLoading } = useAppSelector(state => state.deleteTrailer);
  const { isLoading: deactivateLoading } = useAppSelector(
    state => state.deactivateTrailer
  );
  const {
    data: rowsTruck,
    isLoading: loadingTruck,
    count: truckCount
  } = useAppSelector(state => state.getTruck);
  const isOpen = Boolean(anchorEl);
  const isOpenFreight = Boolean(anchorEl);
  const handleClose = () => {
    setAnchorEl(null);
  };

  const { control } = useForm({});

  let truckzoneList = ['Trailer', 'Freight' /* 'Truck' */];

  const placeholderText =
    tabValue === 0
      ? [
          'Search for Unit Number',
          'Search for Make',
          'Search for Model',
          'Search for Owner Name',
          'Search for VIN Number',
          'Search for Serial Number',
          'Search for Insurance Name'
        ]
      : tabValue === 1
      ? ['Search for Freight Number', 'Search for Owner Name']
      : [
          'Search for Unit Number',
          'Search for Truck Number',
          'Search for Truck Make',
          'Search for Truck Model'
        ];

  const dynamicOptionsTrailer = [
    {
      id: `${inputValue}`,
      label: `Unit Number :${inputValue}`,
      columnName: 'unitNumber'
    },
    {
      id: `${inputValue}`,
      label: `Make :${inputValue}`,
      columnName: 'make'
    },
    {
      id: `${inputValue}`,
      label: `Model :${inputValue}`,
      columnName: 'model'
    },
    {
      id: `${inputValue}`,
      label: `Owner Name :${inputValue}`,
      columnName: 'ownerName'
    },
    {
      id: `${inputValue}`,
      label: `VIN Number :${inputValue}`,
      columnName: 'vinNumber'
    },
    {
      id: `${inputValue}`,
      label: `Serial Number :${inputValue}`,
      columnName: 'serial_number'
    },
    {
      id: `${inputValue}`,
      label: `Insurance Name :${inputValue}`,
      columnName: 'insuranceName'
    }
  ];

  const dynamicOptionsFreight = [
    {
      id: `${inputValue}`,
      label: `Freight Number :${inputValue}`,
      columnName: 'freightNumber'
    },
    {
      id: `${inputValue}`,
      label: `Owner Name :${inputValue}`,
      columnName: 'ownerName'
    }
  ];

  const dynamicOptionsTruck = [
    {
      id: `${inputValue}`,
      label: `Unit Number :${inputValue}`,
      columnName: 'unitNumber'
    },
    {
      id: `${inputValue}`,
      label: `Truck Number :${inputValue}`,
      columnName: 'vehicleNumber'
    },
    {
      id: `${inputValue}`,
      label: `Truck Make :${inputValue}`,
      columnName: 'vehicleMake'
    },
    {
      id: `${inputValue}`,
      label: `Truck Model :${inputValue}`,
      columnName: 'vehicleModel'
    }
  ];

  // function for dynamic options
  const handleInputChange = async (event: any, newValue: string) => {
    const payload: any = {
      ...tablePayload,
      searchInput: newValue
    };
    if (!newValue) {
      if (truckzoneType === 'Trailer') {
        await dispatch(
          getTrailer({ ...payload, signal: createAbort().abortCall.signal })
        );
      } else if (truckzoneType === 'Freight') {
        await dispatch(
          getFreight({ ...payload, signal: createAbort().abortCall.signal })
        );
      } else {
        await dispatch(getTruck({ ...payload, signal: createAbort().abortCall.signal }));
      }
      setTablePayload(payload);
      setPageNo(1);
      setPageSize(5);
    }

    setInputValue(newValue);
  };

  // function for filter Search
  const handleSearchColumnChange = async (event: any, newValue: any) => {
    const payload = {
      ...tablePayload,
      searchColumnName: newValue?.columnName,
      searchInput: newValue?.id
    };
    setTablePayload(payload);

    if (truckzoneType === 'Trailer') {
      await dispatch(getTrailer({ ...payload, signal: createAbort().abortCall.signal }));
    } else if (truckzoneType === 'Freight') {
      await dispatch(getFreight({ ...payload, signal: createAbort().abortCall.signal }));
    } else {
      await dispatch(getTruck({ ...payload, signal: createAbort().abortCall.signal }));
    }
    setPageNo(1);
    setPageSize(5);
  };

  // function for normal search

  const handleSearch = async () => {
    const payload = {
      ...tablePayload,
      pageNo: 1,
      pageSize: 5,
      searchInput: inputValue
    };
    setTablePayload(payload);

    if (truckzoneType === 'Trailer') {
      await dispatch(getTrailer({ ...payload, signal: createAbort().abortCall.signal }));
    } else if (truckzoneType === 'Freight') {
      await dispatch(getFreight({ ...payload, signal: createAbort().abortCall.signal }));
    } else {
      await dispatch(getTruck({ ...payload, signal: createAbort().abortCall.signal }));
    }
    setPageNo(1);
    setPageSize(5);
  };

  const BlurryDialog = styled(Dialog)<DialogProps>(({ theme }) => ({
    backgroundColor: 'rgba(60, 60, 60, 0.5)'
  }));

  const MemoizedDialog = useCallback(BlurryDialog, [files?.length]);

  const handleUpdate = (params: any) => {
    setFilteredRow(params);
    setTablePayload({
      ...tablePayload,
      pageNo: 1,
      pageSize: 5
    });
  };

  // handle delete
  const handleDelete = async () => {
    if (filteredRow?.type === 'Trailer') {
      let action1 = await dispatch(deleteTrailer(filteredRow?.id));
      if (deleteTrailer.fulfilled.match(action1)) {
        setPageNo(1);
        setPageSize(5);
        await dispatch(
          getTrailer({
            pageNo: 1,
            pageSize: 5
          })
        );
      }
    }
    if (filteredRow?.type === 'Freight') {
      let action2 = await dispatch(deleteFreight(filteredRow?.id));
      if (deleteFreight.fulfilled.match(action2)) {
        setPageNo(1);
        setPageSize(5);
        await dispatch(
          getFreight({
            pageNo: 1,
            pageSize: 5
          })
        );
      }
    }
    setTablePayload({
      ...tablePayload,
      pageNo: 1,
      pageSize: 5
    });
    setIsDelete(false);
  };

  // handle deactivate
  const handleDeactivate = async () => {
    if (filteredRow?.type === 'Trailer') {
      const action1 = await dispatch(deactiveTrailer(filteredRow?.id));
      if (deactiveTrailer.fulfilled.match(action1)) {
        setPageNo(1);
        setPageSize(5);
      }
    }
    if (filteredRow?.type === 'Freight') {
      const action2 = await dispatch(PatchFreight(filteredRow?.id));
      if (PatchFreight.fulfilled.match(action2)) {
        setPageNo(1);
        setPageSize(5);
      }
    }
    setTablePayload({
      ...tablePayload,
      pageNo: 1,
      pageSize: 5
    });

    setIsActivate(false);
  };

  // handle pagination
  const handlePagination = async (newPaginationModel: PaginationModel) => {
    if (sortModel.length > 0) {
      if (truckzoneType === 'Trailer') {
        await dispatch(
          getTrailer({
            ...pagination(newPaginationModel),
            ...(sortModel?.length > 0
              ? { sortBy: sortModel[0].sort, sortColumnName: sortModel[0].field }
              : []),
            signal: createAbort().abortCall.signal
          })
        );
      } else if (truckzoneType === 'Freight') {
        await dispatch(
          getFreight({
            ...pagination(newPaginationModel),
            ...(sortModel?.length > 0
              ? { sortBy: sortModel[0].sort, sortColumnName: sortModel[0].field }
              : []),
            signal: createAbort().abortCall.signal
          })
        );
      } else {
        await dispatch(
          getTruck({
            ...pagination(newPaginationModel),
            ...(sortModel?.length > 0
              ? { sortBy: sortModel[0].sort, sortColumnName: sortModel[0].field }
              : []),
            signal: createAbort().abortCall.signal
          })
        );
      }
    } else {
      if (truckzoneType === 'Trailer') {
        await dispatch(
          getTrailer({
            ...pagination(newPaginationModel),
            signal: createAbort().abortCall.signal
          })
        );
      } else if (truckzoneType === 'Freight') {
        await dispatch(
          getFreight({
            ...pagination(newPaginationModel),
            signal: createAbort().abortCall.signal
          })
        );
      } else {
        await dispatch(
          getTruck({
            ...pagination(newPaginationModel),
            signal: createAbort().abortCall.signal
          })
        );
      }
    }
  };

  // handle sorting
  const handleSortModelChange = async (model: any) => {
    setSortModel(model);
    const payload = {
      ...tablePayload,
      sortColumnName: (model.length > 0 && model[0].field) || null,
      sortBy: (model.length > 0 && model[0].sort.toUpperCase()) || null
    };
    setTablePayload(payload);
    if (truckzoneType === 'Trailer') {
      await dispatch(getTrailer({ ...payload, signal: createAbort().abortCall.signal }));
    } else if (truckzoneType === 'Freight') {
      await dispatch(getFreight({ ...payload, signal: createAbort().abortCall.signal }));
    } else {
      await dispatch(getTruck({ ...payload, signal: createAbort().abortCall.signal }));
    }
  };

  // handle customtab
  const handleTruck = async (e: any, newValue: any) => {
    setTablePayload({
      pageNo: 1,
      pageSize: 5,
      sortColumnName: null,
      sortBy: null,
      searchInput: null,
      searchColumnName: null
    });
    setPageNo(1);
    setFilteredRow(null);
    setTabValue(newValue);
    switch (newValue) {
      case 0:
        setTruckzoneType('Trailer');
        setInputValue('');
        await dispatch(
          getTrailer({ ...pagination, signal: createAbort().abortCall.signal })
        );
        break;
      case 1:
        setTruckzoneType('Freight');
        setInputValue('');
        await dispatch(
          getFreight({ ...pagination, signal: createAbort().abortCall.signal })
        );
        break;
      case 2:
        setTruckzoneType('Truck');
        setInputValue('');
        await dispatch(
          getTruck({ ...pagination, signal: createAbort().abortCall.signal })
        );
        break;
      default:
        break;
    }
  };

  // handle start interval
  const startInterval = () => {
    stopInterval();
    intervalId.current = setInterval(() => {
      setIndex(prevIndex => {
        return prevIndex === placeholderText.length - 1 ? 0 : prevIndex + 1;
      });
      if (inputValue.length > 0) {
        stopInterval();
      }
    }, 2000);
  };

  // Function to stop the interval
  const stopInterval = () => {
    if (intervalId.current) {
      clearInterval(intervalId.current);
      intervalId.current = null;
    }
  };

  const handleImage = () => {
    handleClose();
    if (
      (filteredRow?.licenseGetURLList &&
        Object.keys(filteredRow?.licenseGetURLList).length > 0) ||
      (filteredRow?.insuranceGetURLList &&
        Object.keys(filteredRow?.insuranceGetURLList).length > 0)
    ) {
      setImageCard(true);
      const combinedUrls = [
        ...Object.values(filteredRow?.licenseGetURLList || {}),
        ...Object.values(filteredRow?.insuranceGetURLList || {})
      ];
      setFiles(combinedUrls);
    }
  };

  useEffect(() => {
    if (rows?.length > 0) {
      setTrailerRows(rows);
    } else if (rows?.length === 0) {
      setTrailerRows([]);
    }
    if (data?.length > 0) {
      setFreightRows(data);
    } else if (data?.length === 0) {
      setFreightRows([]);
    }
    if (rowsTruck?.length > 0) {
      setTruckRows(rowsTruck);
    } else if (rowsTruck?.length === 0) {
      setTruckRows([]);
    }
  }, [rows, data, rowsTruck, sortModel[0]?.sort, sortModel[0]?.columnName]);

  useEffect(() => {
    dispatch(getTrailer({ ...pagination, signal: createAbort().abortCall.signal }));
    return () => {
      createAbort().abortCall.abort();
    };
  }, []);

  // useEffect(() => {
  //   if (inputValue.length > 0) {
  //     stopInterval();
  //   } else {
  //     startInterval();
  //   }
  // }, [inputValue]);

  // useEffect(() => {
  //   setIndex(0);
  //   startInterval();
  // }, [tabValue]);

  let trailerColumns = [
    {
      field: 'isActive',
      headerName: `Status`,
      flex: 1,
      minWidth: 100,
      renderCell: ({ value }: GridCellProps) =>
        value === 1 ? (
          <Icon icon='carbon:circle-filled' style={{ color: '#0EBC93' }} />
        ) : (
          <Icon icon='carbon:circle-filled' style={{ color: '#FF2532' }} />
        )
    },
    {
      field: 'unitNumber',
      headerName: `Unit Number`,
      flex: 1,
      minWidth: 150,
      renderCell: (params: any) => params.value.toUpperCase()
    },
    {
      field: 'make',
      headerName: `Make`,
      flex: 1,
      minWidth: 150,
      renderCell: (params: any) => capitalizeFirstLetter(params.value)
    },
    {
      field: 'model',
      headerName: `Model`,
      flex: 1,
      minWidth: 150,
      renderCell: (params: any) => capitalizeFirstLetter(params.value)
    },
    {
      field: 'modelYear',
      headerName: `Manufactured Year`,
      flex: 1,
      minWidth: 150
    },
    {
      field: 'ownedOrHired',
      headerName: `Ownership`,
      flex: 1,
      sortable: false,
      minWidth: 150,
      renderCell: (params: any) => capitalizeFirstLetter(params.value)
    },
    {
      field: 'ownerName',
      headerName: `Owner Name`,
      flex: 1,
      minWidth: 150,
      renderCell: (params: any) => capitalizeFirstLetter(params.value)
    },
    {
      field: 'vinNumber',
      headerName: `VIN Number`,
      flex: 1,
      minWidth: 150,
      renderCell: (params: any) => params.value.toUpperCase()
    },
    {
      field: 'trailerType',
      headerName: `Trailer Type`,
      flex: 1,
      minWidth: 200
    },
    {
      field: 'trailerGroup',
      headerName: `Trailer Group`,
      flex: 1,
      minWidth: 150
    },
    {
      field: 'serial_number',
      headerName: `Serial Number`,
      flex: 1,
      minWidth: 150
    },
    {
      field: 'trailerAxleNumber',
      headerName: `Axle Number`,
      flex: 1,
      minWidth: 150
    },
    {
      field: 'trailerUnladenWeight',
      headerName: `Unladen Weight`,
      flex: 1,
      minWidth: 150,
      renderCell: ({ row }: any) => {
        return String(row.trailerUnladenWeight).concat(' ', row.trailerUnladenWeightUnit);
      }
    },
    {
      field: 'length',
      headerName: `Length`,
      flex: 1,
      minWidth: 150,
      renderCell: ({ row }: any) => {
        return String(row.length).concat(' ', row.dimensionUnit);
      }
    },
    {
      field: 'width',
      headerName: `Width`,
      flex: 1,
      minWidth: 150,
      renderCell: ({ row }: any) => {
        return String(row.width).concat(' ', row.dimensionUnit);
      }
    },
    {
      field: 'dotInspectionDate',
      headerName: `DOT Inspection Date`,
      flex: 1,
      minWidth: 160
    },
    {
      field: 'registeredState',
      headerName: `Registered State`,
      flex: 1,
      minWidth: 150
    },
    {
      field: 'licenseRegisterNumber',
      headerName: `License Number`,
      sortable: false,
      flex: 1,
      minWidth: 150
    },
    {
      field: 'licenseExpiry',
      headerName: `License Expiry Date`,
      sortable: false,
      flex: 1,
      minWidth: 150
    },
    {
      field: 'insuranceRegisterNumber',
      headerName: `Policy Number`,
      sortable: false,
      flex: 1,
      minWidth: 150
    },
    {
      field: 'insuranceExpiry',
      headerName: `Insurance Expiry Date`,
      sortable: false,
      flex: 1,
      minWidth: 160
    },
    {
      field: 'insuranceName',
      headerName: `Insurance Name`,
      flex: 1,
      minWidth: 150
    },
    {
      field: 'description',
      headerName: `Description`,
      flex: 1,
      minWidth: 150
    },
    {
      field: 'actions',
      headerName: 'Actions',
      flex: 1,
      minWidth: 150,
      renderCell: ({ row }: any) => (
        <Box>
          <Tooltip title='Menu' placement='right' arrow>
            <IconButton
              id='basic-button'
              sx={{ display: 'flex', justifyContent: 'flex-start', pl: 0 }}
              aria-controls={isOpen ? 'basic-menu' : undefined}
              aria-haspopup='true'
              aria-expanded={isOpen ? 'true' : undefined}
              onClick={event => {
                setRole(row?.roleType);
                setLabel(`Update Trailer`);
                setType(`Update Trailer`);
                handleUpdate(row);
                setFilteredRow(row);
                setAnchorEl(event.currentTarget);
                setTextValue(row?.licenseGetURLList || row?.insuranceGetURLList);
              }}
            >
              <Icon icon='eva:menu-2-outline' className='white-bg' />
            </IconButton>
          </Tooltip>
          <Menu anchorEl={anchorEl} open={isOpen} onClose={handleClose}>
            <MenuItem
              disabled={filteredRow?.isActive === 0}
              onClick={e => {
                setIsUpdate(true);
                setOpen(true);
                handleClose();
              }}
            >
              <CustomIconButton category='Update' showTooltip={false} /> {''}
              {constants.Update}
            </MenuItem>
            {(filteredRow && Object.keys(filteredRow?.licenseGetURLList).length > 0) ||
            (filteredRow && Object.keys(filteredRow?.insuranceGetURLList).length > 0) ? (
              <MenuItem
                disabled={filteredRow?.isActive === 0}
                className='menu-dialog'
                onClick={() => handleImage()}
              >
                <FilePresentIcon style={{ marginRight: '8px', color: '#9f9f01' }} />
                Documents
              </MenuItem>
            ) : (
              <MenuItem className='menu-dialog' disabled>
                <FilePresentIcon style={{ marginRight: '8px' }} />
                Documents (N/A)
              </MenuItem>
            )}
            <MenuItem
              onClick={() => {
                setIsActivate(true);
                handleClose();
              }}
            >
              {filteredRow?.isActive === 0 ? (
                <CustomIconButton showTooltip={false} category='Active' />
              ) : (
                <CustomIconButton showTooltip={false} category='Deactive' />
              )}
              {filteredRow?.isActive === 0 ? constants.ActiveStatus : constants.Deactive}
            </MenuItem>
            <MenuItem
              disabled={filteredRow?.isActive === 0}
              onClick={() => {
                setIsDelete(true);
                setMessage(`${constants.DeleteCustomer} Trailer?`);
                handleClose();
              }}
            >
              <CustomIconButton category='Delete' showTooltip={false} /> {''}
              {constants.Delete}
            </MenuItem>
          </Menu>
        </Box>
      )
    }
  ];

  let freightColumns = [
    {
      field: 'isActive',
      headerName: `Status`,
      flex: 1,
      minWidth: 100,
      renderCell: ({ value }: GridCellProps) =>
        value === 1 ? (
          <Icon icon='carbon:circle-filled' style={{ color: '#0EBC93' }} />
        ) : (
          <Icon icon='carbon:circle-filled' style={{ color: '#FF2532' }} />
        )
    },
    {
      field: 'freightNumber',
      headerName: `Freight Number`,
      flex: 1,
      minWidth: 150
    },
    {
      field: 'ownership',
      headerName: `Ownership`,
      flex: 1,
      minWidth: 150
    },
    {
      field: 'ownerName',
      headerName: `Owner Name`,
      flex: 1,
      minWidth: 150
    },
    {
      field: 'unladenWeight',
      headerName: `Unladen Weight`,
      flex: 1,
      minWidth: 150,
      renderCell: ({ row }: any) => {
        return String(row.unladenWeight).concat(' ', row.freightUnladenWeightUnit);
      }
    },
    {
      field: 'length',
      headerName: `Length`,
      flex: 1,
      minWidth: 150,
      renderCell: ({ row }: any) => {
        return String(row.length).concat(' ', row.dimensionUnit);
      }
    },
    {
      field: 'width',
      headerName: `Width`,
      flex: 1,
      minWidth: 150,
      renderCell: ({ row }: any) => {
        return String(row.width).concat(' ', row.dimensionUnit);
      }
    },
    {
      field: 'breadth',
      headerName: `Breadth`,
      flex: 1,
      minWidth: 150,
      renderCell: ({ row }: any) => {
        return String(row.breadth).concat(' ', row.dimensionUnit);
      }
    },
    {
      field: 'description',
      headerName: `Description`,
      flex: 1,
      minWidth: 150
    },
    {
      field: 'actions',
      headerName: 'Actions',
      flex: 1,
      minWidth: 150,
      renderCell: ({ row }: any) => (
        <Box>
          <Tooltip title='Menu' placement='right' arrow>
            <IconButton
              id='basic-button'
              sx={{ display: 'flex', justifyContent: 'flex-start', pl: 0 }}
              aria-controls={isOpen ? 'basic-menu' : undefined}
              aria-haspopup='true'
              aria-expanded={isOpen ? 'true' : undefined}
              onClick={event => {
                setRole(row?.roleType);
                setLabel(`Update Freight`);
                setType(`Update Freight`);
                handleUpdate(row);
                setFilteredRow(row);
                setAnchorEl(event.currentTarget);
              }}
            >
              <Icon icon='eva:menu-2-outline' className='white-bg' />
            </IconButton>
          </Tooltip>
          <Menu anchorEl={anchorEl} open={isOpenFreight} onClose={handleClose}>
            <MenuItem
              disabled={filteredRow?.isActive === 0}
              onClick={() => {
                setIsUpdate(true);
                setOpen(true);
                handleClose();
              }}
            >
              <CustomIconButton category='Update' showTooltip={false} /> {''}
              {constants.Update}
            </MenuItem>
            <MenuItem
              onClick={() => {
                setIsActivate(true);
                handleClose();
              }}
            >
              {filteredRow?.isActive === 0 ? (
                <CustomIconButton showTooltip={false} category='Active' />
              ) : (
                <CustomIconButton showTooltip={false} category='Deactive' />
              )}
              {filteredRow?.isActive === 0 ? constants.ActiveStatus : constants.Deactive}
            </MenuItem>
            <MenuItem
              disabled={filteredRow?.isActive === 0}
              onClick={() => {
                setIsDelete(true);
                setMessage(`${constants.DeleteCustomer} Freight?`);
                handleClose();
              }}
            >
              <CustomIconButton category='Delete' showTooltip={false} /> {''}
              {constants.Delete}
            </MenuItem>
          </Menu>
        </Box>
      )
    }
  ];

  let truckColumns = [
    {
      field: 'unitNumber',
      headerName: `Unit Number`,
      flex: 1,
      minWidth: 100
    },
    {
      field: 'vehicleNumber',
      headerName: `Truck Number`,
      flex: 1,
      minWidth: 150
    },
    {
      field: 'vehicleMake',
      headerName: `Truck Make`,
      flex: 1,
      minWidth: 150
    },
    {
      field: 'vehicleModel',
      headerName: `Truck Model`,
      flex: 1,
      minWidth: 150
    },
    {
      field: 'manufacturedYear',
      headerName: `Manufactured Year`,
      flex: 1,
      minWidth: 150
    },
    {
      field: 'yearOfPurchase',
      headerName: `Year of Purchase`,
      flex: 1,
      minWidth: 150
    },
    {
      field: 'numberOfAxles',
      headerName: `Number of Axles`,
      flex: 1,
      minWidth: 150
    },
    {
      field: 'unladenWeight',
      headerName: `Unladen Weight`,
      flex: 1,
      minWidth: 150,
      renderCell: ({ row }: any) => {
        return String(row.truckUnladenWeight).concat(' ', row.weightUnits);
      }
    },
    {
      field: 'height',
      headerName: `Height`,
      flex: 1,
      minWidth: 150,
      renderCell: ({ row }: any) => {
        return String(row.height).concat(' ', row.dimensionalUnits);
      }
    },
    {
      field: 'grossVehicleWeight',
      headerName: `Gross Vehicle Weight`,
      flex: 1,
      minWidth: 170
    },
    {
      field: 'insuranceRegisterNumber',
      headerName: `Insurance Number`,
      sortable: false,
      flex: 1,
      minWidth: 150
    },
    {
      field: 'insuranceExpiry',
      headerName: `Insurance Expiry Date`,
      sortable: false,
      flex: 1,
      minWidth: 160
    },
    {
      field: 'licenseRegisterNumber',
      headerName: `License Number`,
      sortable: false,
      flex: 1,
      minWidth: 150
    },
    {
      field: 'licenseExpiry',
      headerName: `License Expiry Date`,
      sortable: false,
      flex: 1,
      minWidth: 150
    },
    {
      field: 'fitnessRegisterNumber',
      headerName: `Fitness Number`,
      sortable: false,
      flex: 1,
      minWidth: 150
    },
    {
      field: 'fitnessExpiry',
      headerName: `Fitness Expiry Date`,
      sortable: false,
      flex: 1,
      minWidth: 150
    },
    {
      field: 'update',
      headerName: `Update`,
      headerAlign: 'center',
      flex: 1,
      minWidth: 150,
      align: 'center',
      renderCell: ({ row }: any) => (
        <Box>
          <CustomIconButton
            category='Update'
            showTooltip={false}
            onClick={(event: any) => {
              setRole(row?.roleType);
              setLabel(`Update Truck`);
              setType(`Update Truck`);
              handleUpdate(row);
              setFilteredRow(row);
              setIsUpdate(true);
              setOpen(true);
            }}
          />
        </Box>
      )
    }
  ];

  return (
    <>
      <Box className='truckZone' sx={{ position: 'relative', marginBottom: '30px' }}>
        <Box>
          <CustomTab onChange={handleTruck} value={tabValue} tabList={truckzoneList} />
          {tabValue !== 2 && (
            <Box className='truck-title'>
              <CustomButton
                category={truckzoneType === 'Trailer' ? 'Add Trailer' : 'Add Freight'}
                className='saveChanges'
                onClick={() => {
                  setOpen(true);
                  setTextValue('');
                  setRole(truckzoneType === 'Trailer' ? 'Add Trailer' : 'Add Freight');
                  setFilteredRow(null);
                  setType(truckzoneType === 'Trailer' ? 'Add Trailer' : 'Add Freight');
                  setLabel(truckzoneType === 'Trailer' ? 'Add Trailer' : 'Add Freight');
                }}
              />
            </Box>
          )}
        </Box>

        <Box
          sx={{
            display: 'flex',
            justifyContent: 'flex-end',
            marginTop: '20px'
          }}
        >
          <CustomSearch
            id='searchField'
            control={control}
            name='searchField'
            options={
              tabValue === 0
                ? dynamicOptionsTrailer
                : tabValue === 1
                ? dynamicOptionsFreight
                : dynamicOptionsTruck
            }
            // placeholder={placeholderText[index]}
            placeholder='Search for ...'
            icon={<i className='custom-icon' />}
            variant='standard'
            inputValue={inputValue}
            handleInputChange={handleInputChange}
            onChanges={handleSearchColumnChange}
            handleSearchClick={handleSearch}
          />
        </Box>

        <Box sx={{ marginTop: '20px' }}>
          {truckzoneType === 'Trailer' && (
            <CustomDataGrid
              rows={trailerRows}
              columns={trailerColumns}
              loading={loading}
              onSortModelChange={handleSortModelChange}
              rowCount={trailerCount}
              sortingMode='server'
              type={'logistics'}
              pageNo={pageNo}
              pageSize={pageSize}
              paginationModel={{
                page: pageNo && trailerCount ? pageNo - 1 : 0,
                pageSize: pageSize ? pageSize : 5
              }}
              onPaginationModelChange={handlePagination}
            />
          )}
          {truckzoneType === 'Freight' && (
            <CustomDataGrid
              rows={freightRows}
              columns={freightColumns}
              loading={isLoading}
              onSortModelChange={handleSortModelChange}
              rowCount={count}
              sortingMode='server'
              type={'logistics'}
              pageNo={pageNo}
              pageSize={pageSize}
              paginationModel={{
                page: pageNo && count ? pageNo - 1 : 0,
                pageSize: pageSize ? pageSize : 5
              }}
              onPaginationModelChange={handlePagination}
            />
          )}
          {truckzoneType === 'Truck' && (
            <CustomDataGrid
              rows={truckRows}
              columns={truckColumns}
              loading={loadingTruck}
              onSortModelChange={handleSortModelChange}
              rowCount={truckCount}
              sortingMode='server'
              type={'logistics'}
              pageNo={pageNo}
              pageSize={pageSize}
              paginationModel={{
                page: pageNo && truckCount ? pageNo - 1 : 0,
                pageSize: pageSize ? pageSize : 5
              }}
              onPaginationModelChange={handlePagination}
            />
          )}
        </Box>
      </Box>
      {open && (
        <>
          {type === 'Add Trailer' || type === 'Update Trailer' ? (
            <AddTrailers
              open={open}
              setOpen={setOpen}
              roleType={type}
              setPageNo={setPageNo}
              setPageSize={setPageSize}
              label={label}
              filteredRow={filteredRow}
              setTextValue={setTextValue}
            />
          ) : type === 'Add Truck' || type === 'Update Truck' ? (
            <AddTrucksZone
              open={open}
              setOpen={setOpen}
              setPageNo={setPageNo}
              setPageSize={setPageSize}
              roleType={type}
              filteredRow={filteredRow}
            />
          ) : (
            <AddFreights
              open={open}
              setOpen={setOpen}
              setPageNo={setPageNo}
              setPageSize={setPageSize}
              roleType={type}
              filteredRow={filteredRow}
            />
          )}
        </>
      )}

      {isDelete && (
        <CustomDeletePopup
          open={isDelete}
          setOpen={setIsDelete}
          handleDelete={handleDelete}
          handleClose={handleClose}
          message={message}
          isLoading={filteredRow?.type === 'Trailer' ? deleteLoading : isLoading}
        />
      )}
      {isActivate && (
        <CustomActivatePopup
          filteredRow={filteredRow}
          open={isActivate}
          setOpen={setIsActivate}
          handleDeactivate={handleDeactivate}
          isLoading={filteredRow?.type === 'Trailer' ? deactivateLoading : isLoading}
        />
      )}
      {imageCard && (
        <MemoizedDialog
          open={true}
          fullWidth
          fullScreen
          maxWidth='md'
          className='dialog'
          onClose={() => setImageCard(false)}
          PaperProps={{
            style: {
              backgroundColor: 'transparent',
              boxShadow: 'none'
            }
          }}
        >
          <DialogContent
            className='dialogContent'
            sx={{
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center'
            }}
          >
            <Box className='closeIcon icon-position d-flex'>
              <CustomIconButton
                category='CloseValue'
                onClick={() => {
                  setImageCard(false);
                }}
              />
            </Box>
            <CustomCarousel image={files} />
          </DialogContent>
        </MemoizedDialog>
      )}
    </>
  );
};

export default Trucks;
